import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { RoleService } from '@perval/shared';
import { CognitoService } from '../../authentification/services/cognito/cognito.service';

@Injectable({
  providedIn: 'root',
})
export class IsAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private cognitoService: CognitoService,
    private readonly roleService: RoleService,
  ) {}

  async canActivate(): Promise<boolean> {
    const isAuthenticated: boolean =
      await this.cognitoService.isAuthenticated();
    const isSessionValid: boolean = await this.cognitoService.isSessionValid();

    if (!isAuthenticated || !isSessionValid) {
      await this.handleUnauthorizedAccess();
      return false;
    }

    return true;
  }

  private async handleUnauthorizedAccess(): Promise<void> {
    const isSessionExpired: boolean =
      !(await this.cognitoService.isSessionValid());

    if (isSessionExpired) {
      await this.router.navigate(['connexion'], {
        queryParams: { message: 'session-expired' },
      });
    } else {
      await this.router.navigate(['connexion']);
    }
  }
}
